// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ApiKeyOut } from './apiKeyOut.zod.ts';

export const ApiKeyListOut = zod.object({
  "keys": zod.array(ApiKeyOut)
});

export type ApiKeyListOut = zod.input<typeof ApiKeyListOut>;
export type ApiKeyListOutOutput = zod.output<typeof ApiKeyListOut>;
